export default {
  viewFullscreen: 'View fullscreen',
  exitFullscreen: 'Exit fullscreen',
  removeSelectedPoint: 'Remove selected point',
  removeSelectedPoints: 'Remove selected points',
  showPlansOnMap: 'Show plans on map',
  hidePlansOnMap: 'Hide plans on map',
  chooseThisPointAs_: 'Choose this point as {title}',
  coordinates: 'Coordinates',
  submit_: 'Submit {title}',
  extractingAddress: 'Extracting address ...',
  newDestination: 'New destination',
  theSelectedCoordinatesAreWithinThe_:
    'The selected coordinates are within the',
  position: 'Position',
  leaflet: 'Leaflet',
  defaultLatitude: 'Default latitude',
  defaultLongitude: 'Default longitude',
  defaultZoom: 'Default zoom',
  defaultTheme: 'Default theme',
  markerPrimaryColor: 'Marker primary color',
  markerSecondaryColor: 'Marker secondary color',
  scrollZoom: 'Zoom with scroll',
  minZoom: 'Minimum zoom',
  maxZoom: 'Maximum zoom',
  rtlUrl: 'RTL url',
  styleUrlLight: 'Light map theme',
  styleUrlDark: 'Dark map theme',
  styleUrlSat: 'Satellite map theme',
  apiKey: 'Api key',
  light: 'Light',
  dark: 'Dark',
  satellite: 'Satellite',
  extractingPointInfo: 'Extracting point info ...'
}
